var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "url(#paint0_linear_2460_2186)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9414 34.9609L27.4883 14.5234C27.0117 13.4668 26.3027 12.9512 25.3691 12.9512H24.6211C23.6875 12.9512 22.9785 13.4668 22.502 14.5234L18.8223 23.4277H16.0391C15.6383 23.4301 15.2547 23.5903 14.9713 23.8737C14.688 24.157 14.5277 24.5407 14.5254 24.9414V24.9609C14.5313 25.793 15.209 26.4688 16.0391 26.4746H17.5332L14.0215 34.9609C13.957 35.1484 13.918 35.3418 13.918 35.541C13.918 36.0176 14.0664 36.3906 14.3301 36.6816C14.5938 36.9707 14.9746 37.1133 15.4512 37.1133C15.7676 37.1074 16.0703 37.0098 16.3203 36.8242C16.5918 36.6367 16.7773 36.3672 16.9258 36.0566L20.791 26.4688H23.4707C23.8714 26.4664 24.2551 26.3062 24.5384 26.0228C24.8218 25.7394 24.982 25.3558 24.9844 24.9551V24.916C24.9785 24.084 24.3008 23.4082 23.4707 23.4023H22.041L24.9922 16.0508L33.0332 36.0508C33.1816 36.3594 33.3691 36.6309 33.6387 36.8184C33.8906 37.0059 34.1992 37.1016 34.5078 37.1074C34.9844 37.1074 35.3574 36.9648 35.6289 36.6758C35.9004 36.3867 36.041 36.0117 36.041 35.5352C36.0469 35.3418 36.0156 35.1426 35.9375 34.9609H35.9414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6797 37.9707L42.3379 42.418V25.4883L34.6797 37.9707Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3379 25.4883V42.418L49.9961 37.9707L42.3379 25.4883Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3398 34.5527L49.9961 37.9707L42.3398 42.416V34.5508V34.5527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3379 34.5527H42.3398V42.418H42.3379L34.6797 37.9727L42.3379 34.5527Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6797 39.3984L42.3379 50V43.8437L34.6797 39.3984Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3379 43.8437V50L50 39.3984L42.3379 43.8437Z",
    fill: "#878787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2460_2186",
    x1: 43.5312,
    y1: 9.46094,
    x2: 7.15625,
    y2: 41.2891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6509E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EBAC6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.cd808ec879f8536a04123d91f335d77f.svg";
export { ForwardRef as ReactComponent };